export function initDescriptionCollapse() {
  const descriptions = document.querySelectorAll('.itemcardDescription--collapsible');

  descriptions.forEach(desc => {
    const content = desc.querySelector('.slidecontentItem__content');
    if (!content) return;

    if (content.scrollHeight <= 540) {
      desc.classList.remove('itemcardDescription--collapsible');
      return;
    }

    const showMore = document.createElement('span');
    showMore.className = 'itemcardDescription__showMore link';
    showMore.textContent = '+ ' + GLOBALS.tc.showMore;
    desc.appendChild(showMore);

    desc.addEventListener('click', () => {
      desc.classList.toggle('is-expanded');
      showMore.textContent = desc.classList.contains('is-expanded')
        ? '- ' + GLOBALS.tc.showLess
        : '+ ' + GLOBALS.tc.showMore;
    });
  });
}
